import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Grid2,
  Icon,
  IconButton,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialBox from "../../../components/MaterialBox";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import MaterialInput from "../../../components/MaterialInput";
import PercentIcon from "@mui/icons-material/Percent";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MaterialButton from "../../../components/MaterialButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import Swal from "sweetalert2";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import { useLoading } from "../../../context/loading";
import { fetchAll } from "../../../ApiBaseUrl";

function AddBonus() {
  const navigate = useNavigate();
  const location = useLocation();
  const { circleLoading, setCirleLoading } = useLoading();
  const id = location?.state?.id || null;

  const [togglePage, setTogglePage] = useState({
    view: id ? true : false,
    edit: false,
  });

  const [loading, setLoading] = useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const yearOptions = [
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
  ];
  const categoryOptions = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];
  const typeOptions = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];

  const [bonusData, setBonusData] = useState({
    bonusId: "",
    month: "",
    year: "",
    category: "",
    employeeType: "",
    branch: "",
    shift: "",
    bonusType: "",
    employeeId: "",
    percentage: "",
    sumOfBasic: "",
    bonusAmount: "",
    bonusDetails: [],

    monthStatus: "unchecked",
    yearStatus: "unchecked",
    categoryStatus: "unchecked",
    employeeTypeStatus: "unchecked",
    branchStatus: "unchecked",
    shiftStatus: "unchecked",
    bonusTypeStatus: "unchecked",
    employeeIdStatus: "unchecked",
    percentageStatus: "unchecked",
    sumOfBasicStatus: "unchecked",
    bonusAmountStatus: "unchecked",
  });

  const [originalData, setOriginalData] = useState({
    employeeType: "",
    category: "",
    employee: "",
    employeeId: "",
    amount: "",
    requestedOn: "",
    paymentMode: "",
  });

  const [employeeOptions, setEmployeeOptions] = useState([]);
  const toggleEdit = () => {
    setOriginalData(bonusData);
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const handleDropdownChange = (name, selectedValue) => {
    setBonusData((prevbonusData) => {
      const updatedState = {
        ...prevbonusData,
        [name]: selectedValue,
        [`${name}Status`]: "success",
      };

      if (name === "employeeId") {
        fetchBasicPay(selectedValue);
      }
      return updatedState;
    });
  };

  const fetchBonusById = async () => {
    if (!id) return;

    const getBonusById = gql`
      query BonusById($id: Int!) {
        bonusById(id: $id) {
          id
          employee {
            empid
          }
          month
          year
          bonusType
          employeeCategory
          employeeType
          branch
          shift
          sumOfBasic
          percentage
          bonusAmount
          createdAt
        }
      }
    `;

    setCirleLoading(true);
    try {
      const response = await request(BASEURL, getBonusById, { id });
      if (response?.bonusById) {
        setBonusData((prev) => ({
          ...prev,
          category: response.bonusById.employeeCategory,
          shift: {
            value: response.bonusById.shift,
            label: response.bonusById.shift,
          },

          month: response?.bonusById?.month + "",
          year: response?.bonusById?.year + "",
          employeeType: response?.bonusById.employeeType,
          branch: {
            value: response?.bonusById?.branch,
            label: response?.bonusById?.branch,
          },
          bonusType: response?.bonusById?.bonusType,
          employeeId: {
            value: response?.bonusById?.employee?.empid,
            label: response?.bonusById?.employee?.empid,
          },
          percentage: response?.bonusById?.percentage,
          bonusAmount: response?.bonusById?.bonusAmount,

          categoryStatus: response.bonusById.employeeCategory
            ? "success"
            : "unchecked",
          shiftStatus: response.bonusById.shift ? "success" : "unchecked",
          monthStatus:
            response?.bonusById?.month + "" ? "success" : "unchecked",
          yearStatus: response?.bonusById?.year + "" ? "success" : "unchecked",
          employeeTypeStatus: response?.bonusById.employeeType
            ? "success"
            : "unchecked",
          branchStatus: response?.bonusById?.branch ? "success" : "unchecked",
          bonusTypeStatus: response?.bonusById?.bonusType
            ? "success"
            : "unchecked",
          employeeIdStatus: response?.bonusById?.employee?.empid
            ? "success"
            : "unchecked",
          percentageStatus: response?.bonusById?.percentage
            ? "success"
            : "unchecked",
          bonusAmountStatus: response?.bonusById?.bonusAmount
            ? "success"
            : "unchecked",
        }));

        setTogglePage({ view: true, edit: false });
      }
    } catch (error) {
      console.error("Error fetching bonus details", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    fetchBonusById();
  }, [id]);

  const fetchActiveEmployees = async () => {
    const getActiveEmployees = gql`
      query ActiveEmployees(
        $branch: String
        $employeeType: String
        $Category: String
        $shift: String
      ) {
        activeEmployees(
          branch: $branch
          employeeType: $employeeType
          category: $Category
          shift: $shift
        ) {
          id
          empid
          firstName
          lastName
          dateOfJoining
          isActive
        }
      }
    `;

    setCirleLoading(true);
    try {
      const response = await request(BASEURL, getActiveEmployees, {
        branch: bonusData?.branch?.value,
        employeeType: bonusData?.employeeType,
        Category: bonusData?.category,
        shift: bonusData?.shift?.value,
      });
      if (response?.activeEmployees?.length > 0) {
        const options = response.activeEmployees.map((emp) => ({
          value: emp.empid,
          label: `${emp.empid} - ${emp?.firstName + emp?.lastName}`,
        }));
        setEmployeeOptions(options);
      }
    } catch (error) {
      console.error("Error Fetching Employee ID", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    // if (
    //   bonusData.category &&
    //   bonusData.branch &&
    //   bonusData.employeeType &&
    //   bonusData.shift
    // ) {
    // if (
    //   bonusData.category &&
    //   bonusData.branch &&
    //   bonusData.employeeType &&
    //   bonusData.shift
    // ) {
    fetchActiveEmployees();
    // }
    // }
  }, [
    bonusData.category,
    bonusData.employeeType,
    bonusData.branch,
    bonusData.shift,
  ]);

  const fetchBasicPay = async (selectedEmployeeId) => {
    if (!selectedEmployeeId) return;

    const getBasicPay = gql`
      query ActiveEmployeesWithBonus(
        $employeeId: String
        $branch: String
        $employeeType: String
        $category: String
        $shift: String
      ) {
        activeEmployeesWithBonus(
          employeeId: $employeeId

          branch: $branch

          employeeType: $employeeType

          category: $category

          shift: $shift
        ) {
          id

          firstName

          lastName

          dateOfJoining

          isActive

          sumOfBasicLast12Months
          basicAmountsMonthWise
        }
      }
    `;

    setCirleLoading(true);
    try {
      const response = await request(BASEURL, getBasicPay, {
        employeeId: bonusData?.employeeId?.value,
      });
      if (response?.activeEmployeesWithBonus?.length > 0) {
        const bonusdetails = JSON.parse(
          response.activeEmployeesWithBonus[0].basicAmountsMonthWise
        );

        const bonusData = Object.entries(bonusdetails).map(([month, data]) => ({
          month,
          data,
        }));

        setBonusData((prev) => ({
          ...prev,
          bonusDetails: bonusData,
          sumOfBasic:
            response.activeEmployeesWithBonus[0].sumOfBasicLast12Months,
          sumOfBasicStatus: "success",
        }));
      }
    } catch (error) {
      console.error("Error fetching Basic Pay", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (bonusData.employeeId) {
      fetchBasicPay(bonusData.employeeId);
    }
  }, [
    bonusData.employeeId,
    bonusData.category,
    bonusData.employeeType,
    bonusData.branch,
    bonusData.shift,
  ]);

  useEffect(() => {
    if (bonusData.percentage && bonusData.sumOfBasic) {
      setBonusData((prev) => ({
        ...prev,
        bonusAmount: (bonusData.percentage / 100) * bonusData.sumOfBasic,
        bonusAmountStatus: "success",
      }));
    } else {
      setBonusData((prev) => ({ ...prev, bonusAmount: "" }));
    }
  }, [bonusData.percentage, bonusData.sumOfBasic]);

  const handleBonusTypeChange = (e) => {
    const value = e.target.value;
    const regex =
      /^[A-Za-z0-9\s@#\$%\^&\*\(\)_\+\-=\[\]\{\};:'"`~,.<>\/?!\\|]{2,25}$/;
    const isValid = regex.test(value);

    setBonusData((prev) => ({
      ...prev,
      bonusType: value,
      bonusTypeStatus: isValid ? "success" : "unchecked",
    }));
  };

  const handleBonusPercentageChange = (e) => {
    let value = e.target.value;

    if (/^\d*\.?\d*$/.test(value) || value === "") {
      if (value === "") {
        setBonusData((prev) => ({
          ...prev,
          percentage: value,
          percentageStatus: "unchecked",
        }));
      } else {
        let numValue = parseFloat(value);
        if (numValue >= 0 && numValue <= 100) {
          setBonusData((prev) => ({
            ...prev,
            percentage: value,
            percentageStatus: "success",
          }));
        }
      }
    }
  };

  const createBonus = gql`
    mutation CreateBonus(
      $month: Int!
      $year: Int!
      $bonusType: String!
      $employeeCategory: String!
      $employeeType: String!
      $branch: String!
      $shift: String!
      $employeeId: String!
      $percentage: Decimal!
    ) {
      createBonus(
        month: $month
        year: $year
        bonusType: $bonusType
        employeeCategory: $employeeCategory
        employeeType: $employeeType
        branch: $branch
        shift: $shift
        employeeId: $employeeId
        percentage: $percentage
      ) {
        bonus {
          id
          month
          year
          bonusType
          employeeCategory
          employeeType
          branch
          shift
          employee {
            id
            firstName
            lastName
          }
          sumOfBasic
          percentage
          bonusAmount
        }
      }
    }
  `;

  const updateBonus = gql`
    mutation UpdateBonus(
      $bonusId: ID!
      $month: Int
      $year: Int
      $bonusType: String
      $employeeCategory: String
      $employeeType: String
      $branch: String
      $shift: String
      $percentage: Decimal
    ) {
      updateBonus(
        bonusId: $bonusId
        month: $month
        year: $year
        bonusType: $bonusType
        employeeCategory: $employeeCategory
        employeeType: $employeeType
        branch: $branch
        shift: $shift
        percentage: $percentage
      ) {
        bonus {
          id
          month
          year
          bonusType
          employeeCategory
          employeeType
          branch
          shift
          percentage
          bonusAmount
        }
      }
    }
  `;

  const handleSubmitBonus = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit the Bonus Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
        setLoading(true);
        setCirleLoading(true);
        const payload = {
          bonusId: id,
          employeeId: bonusData.employeeId?.value,
          month: bonusData.month,
          year: bonusData.year,
          bonusType: bonusData.bonusType,
          employeeCategory: bonusData.category,
          employeeType: bonusData.employeeType,
          branch: bonusData.branch?.value,
          shift: bonusData.shift?.value,
          percentage: bonusData.percentage,
          sumOfBasic: bonusData.sumOfBasic,
          bonusAmount: bonusData.bonusAmount,
        };

        if (togglePage.edit) {
          payload.bonusId = id;
        }

        try {
          const response = await axios.post(BASEURL, {
            query: togglePage.edit ? updateBonus : createBonus,
            variables: payload,
          });

          if (response.data.errors && response.data.errors.length > 0) {
            throw new Error(response.data.errors[0].message);
          }

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Bonus Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/bonus");
        } catch (error) {
          console.error("Could not Submit", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to Submit Bonus",
            text: error.message || "An error occurred.",
            showConfirmButton: true,
            timer: 4000,
          });
        } finally {
          setLoading(false);
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const deleteBonus = gql`
    mutation DeleteBonus($bonusId: ID!) {
      deleteBonus(bonusId: $bonusId) {
        success
        message
      }
    }
  `;

  const handleDeleteBonus = async () => {
    if (!id) return;

    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to delete this bonus?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
        setCirleLoading(true);
        try {
          await axios.post(BASEURL, {
            query: deleteBonus,
            variables: { bonusId: id },
          });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Bonus Deleted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/bonus");
        } catch (error) {
          console.error("Error Deleting", error);
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Failed to Delete Bonus",
            text: error.message || "An error occurred.",
            showConfirmButton: true,
            timer: 5000,
          });
        } finally {
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const handleDiscard = () => {
    setBonusData(originalData);
    setTogglePage({ view: true, edit: false });
  };

  const checkAllFields = () => {
    return (
      bonusData.bonusTypeStatus === "success" &&
      bonusData.branchStatus === "success" &&
      bonusData.categoryStatus === "success" &&
      bonusData.employeeIdStatus === "success" &&
      bonusData.monthStatus === "success" &&
      bonusData.percentageStatus === "success" &&
      bonusData.shiftStatus == "success" &&
      bonusData.sumOfBasicStatus === "success" &&
      bonusData.bonusAmountStatus === "success"
    );
  };
  const [branchList, setBranchList] = useState([]);
  const [shiftList, setShiftList] = useState([]);

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        console.log("All Branches:", data);
        setBranchList(data?.allBranch);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);
  useEffect(() => {
    onShiftDetails();
  }, []);
  const onShiftDetails = async () => {
    // setCirleLoading(true);
    const query = `
      query allShifts{
allShifts {
  id
  name
  startTime
  endTime
  totalWorkingHours
}
}
      `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const shiftData = response.data?.data?.allShifts; // Adjusted field name
      if (shiftData) {
        setShiftList(shiftData);
      } else {
        console.error("Error: Shift data not found in response.");
      }
      // setCirleLoading(false);
    } catch (error) {
      // setCirleLoading(false);
      console.error("ResponseError:", error);
    }
  };
  const styles = {
    bonusTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "15px",
      marginBottom: "15px",
      fontSize: "13px",
      color: "#444",
    },
    bonusTableThTd: {
      border: "1px solid #ccd1d1",
      padding: "8px",
      textAlign: "center",
    },
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  sx={{ mr: 1, mt: -0.7 }}
                  onClick={() => {
                    navigate("/bonus");
                  }}
                >
                  <ArrowBackIcon />
                </IconButton>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.edit
                    ? "Update Bonus details"
                    : togglePage.view
                    ? "View Bonus details"
                    : "Add Bonus Details"}
                </MaterialTypography>
              </Stack>
              {togglePage.view && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handleDeleteBonus}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />

        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Bonus information
            </MaterialTypography>
          </Stack>

          <Grid2 direction="row" container spacing={1}>
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="month"
                options={monthOptions}
                value={
                  monthOptions.find((i) => i.value === bonusData.month) || ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("month", selectedOption.value)
                }
                success={bonusData.monthStatus === "success" ? true : false}
                isDisabled={togglePage.view}
              />
            </Grid2>
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="year"
                options={yearOptions}
                value={
                  yearOptions.find((i) => i.value === bonusData.year) || ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("year", selectedOption.value)
                }
                success={bonusData.yearStatus === "success" ? true : false}
                isDisabled={togglePage.view}
              />
            </Grid2>

            {/* Employee Category */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee Category<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="category"
                options={categoryOptions}
                value={
                  categoryOptions.find((i) => i.value === bonusData.category) ||
                  ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("category", selectedOption.value)
                }
                success={bonusData.categoryStatus === "success" ? true : false}
                isDisabled={togglePage.view}
              />
            </Grid2>

            {/* Employee Type */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee Type<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="employeeType"
                options={typeOptions}
                value={
                  typeOptions.find((i) => i.value === bonusData.employeeType) ||
                  ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("employeeType", selectedOption.value)
                }
                success={
                  bonusData.employeeTypeStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              />
            </Grid2>

            {/* Branch */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Branch<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="branch"
                options={branchList.map((item) => ({
                  value: item.name,
                  label: item.name,
                }))}
                value={bonusData.branch}
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("branch", selectedOption)
                }
                success={bonusData.branchStatus === "success" ? true : false}
                isDisabled={togglePage.view}
              />
            </Grid2>

            {/* Shift */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Shift<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="shift"
                options={shiftList.map((item) => ({
                  value: item?.name,
                  label: item?.name,
                }))}
                value={bonusData.shift}
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("shift", selectedOption)
                }
                success={bonusData.shiftStatus === "success" ? true : false}
                isDisabled={togglePage.view}
              />
            </Grid2>

            {/* Bonus Type */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Bonus Type<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="bonusType"
                value={bonusData.bonusType}
                onChange={handleBonusTypeChange}
                customStyles={{ optionPadding: 20 }}
                success={bonusData.bonusTypeStatus === "success" ? true : false}
                disabled={togglePage.view}
              />
            </Grid2>

            {/* Employee ID */}
            <Grid2 size={{ xs: 5, sm: 3 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Employee ID<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="employeeId"
                value={bonusData.employeeId}
                options={employeeOptions}
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("employeeId", selectedOption)
                }
                success={
                  bonusData.employeeIdStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              />
            </Grid2>
          </Grid2>
          {bonusData?.sumOfBasic !=="" && (
            <MaterialBox>
              <div
                style={{
                  border: "1px solid black",
                  marginTop: "15px",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <MaterialTypography
                  component="label"
                  variant="body2"
                  fontWeight="bold"
                >
                  Bonus
                </MaterialTypography>
                <Grid2>
                  <table style={styles.bonusTable}>
                    <thead>
                      <tr>
                        <th style={styles.bonusTableThTd}>Month</th>
                        <th style={styles.bonusTableThTd}>Bonus</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bonusData?.bonusDetails?.map((item, ind) => {
                        return (
                          <tr>
                            <td style={styles.bonusTableThTd}>{item?.month}</td>
                            <td style={styles.bonusTableThTd}>{item?.data}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Grid2>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 5, sm: 4 }}>
                    <MaterialBox>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Bonus Percentage<span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="number"
                      value={bonusData.percentage}
                      onChange={handleBonusPercentageChange}
                      success={
                        bonusData.percentageStatus === "success" ? true : false
                      }
                      disabled={togglePage.view}
                      icon={{
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <PercentIcon />
                          </Icon>
                        ),
                      }}
                    ></MaterialInput>
                  </Grid2>

                  <Grid2 size={{ xs: 5, sm: 4 }}>
                    <MaterialBox>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Basic Pay<span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      type="number"
                      value={bonusData.sumOfBasic}
                      success={
                        bonusData.sumOfBasicStatus === "success" ? true : false
                      }
                      icon={{
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <CurrencyRupeeIcon />
                          </Icon>
                        ),
                      }}
                      disabled
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 5, sm: 4 }}>
                    <MaterialBox>
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Bonus Amount
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      value={
                        bonusData.percentage && bonusData.sumOfBasic
                          ? (bonusData.percentage / 100) * bonusData.sumOfBasic
                          : ""
                      }
                      success={
                        bonusData.bonusAmountStatus === "success" ? true : false
                      }
                      icon={{
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <CurrencyRupeeIcon />
                          </Icon>
                        ),
                      }}
                      disabled
                    ></MaterialInput>
                  </Grid2>
                </Grid2>
              </div>
            </MaterialBox>
          )}
          {!togglePage?.view && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {" "}
              {togglePage?.edit && (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleDiscard}
                >
                  Discard
                </MaterialButton>
              )}
              <MaterialBox
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
              >
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleSubmitBonus}
                  disabled={!checkAllFields()}
                >
                  {togglePage.edit ? "Update" : "Submit"}
                </MaterialButton>
              </MaterialBox>
            </MaterialBox>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default AddBonus;
